<div class="progress bg-white">
  <div class="progress-bar" role="progressbar" [style]="progressStyle"></div>
</div>
<div class="progress-labels d-flex justify-content-between">
  @for (step of steps(); track step; let index = $index, first = $first, last = $last) {
    <div
      class="d-flex flex-column gap-0 align-items-{{ first ? 'start' : last ? 'end' : 'center' }}"
      [class.pointer]="canSetCurrentStep(index)"
      (click)="setCurrentStep(index)"
    >
      <div class="progress-step" [class.active]="isActive(index)">{{ index + 1 }}</div>
      <div class="progress-label" [class.active]="isActive(index)">{{ step }}</div>
    </div>
  }
</div>
